module.exports = __webpack_public_path__ + "img/nosex.80d35342.png";